import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=a3b767b6&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b767b6')) {
      api.createRecord('a3b767b6', component.options)
    } else {
      api.reload('a3b767b6', component.options)
    }
    module.hot.accept("./ResultsList.vue?vue&type=template&id=a3b767b6&", function () {
      api.rerender('a3b767b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/ResultsList.vue"
export default component.exports